import { UpdateSecondHandSupplyService } from './../../services/update-second-hand-supply.service';
import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SecondHandSupply } from '../../models/second-hand-supply';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-stop-bid',
  templateUrl: './stop-bid.component.html',
  styleUrls: ['./stop-bid.component.scss']
})
export class StopBidComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  stopBidForm = this.fb.group({
    status: ["STOPPED"],
    stop_bid_reason: [null, []]
  })
/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<StopBidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSupply,
    private updateSecondHandSupplyService: UpdateSecondHandSupplyService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  async updateSecondHandSupply(){
    try {
      await this.updateSecondHandSupplyService.updateSecondHandSupplyByPk(this.data.id, this.stopBidForm.value);
      this.toast.openSnackBar("Pre owned supplies is sent for approval");
      this.closeDialog('yes');
    } catch(error){
      this.toast.openSnackBar("Unable to send for pre owned supplies");
    }
  }

  /* --------------------------------- Getters -------------------------------- */
  get status(){
    return this.stopBidForm.get('status');
  }
  get stop_bid_reason(){
    return this.stopBidForm.get('stop_bid_reason');
  }
}



